import { render, staticRenderFns } from "./ClientDialog.vue?vue&type=template&id=4d2ff04b&scoped=true"
import script from "./ClientDialog.vue?vue&type=script&lang=js"
export * from "./ClientDialog.vue?vue&type=script&lang=js"
import style0 from "./ClientDialog.vue?vue&type=style&index=0&id=4d2ff04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ff04b",
  null
  
)

export default component.exports